import React from 'react';
import { Portal } from 'react-portal';
import Media from 'react-media';
import { TopBar, ArticleDetailOverlay } from './style';
import SidePanel from '../sidepanel';
import Cart from '../../containers/cart';
import Nav from '../nav';
import { ActionButton } from '../buttons';
import { NavToggle } from '../toggle';
import { FlexRow, FlexCol } from '../misc';
import ArticleDetail from '../articledetail';

export const TopPortal = () => (
  <Portal>
    <TopBar />
  </Portal>
);

export const CartPortal = ({ showCart, toggleCart }) => (
  <Portal>
    <Media query="(max-width: 40em)">
      {matches => (
        <SidePanel
          hideClick={toggleCart}
          expandDirection="right"
          expandWidth={`${!matches ? '65%' : '100%'}`}
          show={showCart}
        >
          <Cart onCartClose={toggleCart} />
        </SidePanel>
      )}
    </Media>
  </Portal>
);

export const NavPortal = ({ showNav, toggleNav, showPrices, togglePrices }) => (
  <Portal>
    <SidePanel
      hideClick={toggleNav}
      expandDirection="left"
      show={showNav}
      expandWidth="100%"
      maxWidth
    >
      <Nav
        onNavClose={toggleNav}
        togglePrices={togglePrices}
        showPrices={showPrices}
      />
    </SidePanel>
  </Portal>
);

export const ResponsiveFilterPortal = ({
  toggleFilter,
  onFilterReset,
  children,
}) => (
  <Portal
    node={document && document.getElementById('responsive-filter-wrapper')}
  >
    <FlexCol>
      <FlexRow
        css={`
          margin-bottom: 16px;
          justify-content: space-between;
        `}
      >
        <NavToggle onClick={toggleFilter} isExpanded />
        <ActionButton
          onClick={onFilterReset}
          css={`
            max-width: 250px;
          `}
        >
          Suche zurücksezten
        </ActionButton>
      </FlexRow>
      {children}
    </FlexCol>
  </Portal>
);

export const ArticleDetailPortal = ({
  item,
  toggleArticleDetail,
  showDetail,
}) => (
  <Portal>
    <ArticleDetailOverlay show={showDetail}>
      <ArticleDetail onClose={toggleArticleDetail} {...item} />
    </ArticleDetailOverlay>
  </Portal>
);



// WEBPACK FOOTER //
// ./src/components/portals/index.js